'use strict';

var Hounisen = Hounisen || {};
Hounisen.universeSection = new function () {

    function init() {
        // Init functions
        universeSection();
    }

    function universeSection() {

        const section = document.querySelectorAll('.u-section');

        section.forEach(function (item) {

            const parent = item.parentElement;
            const button = parent.getElementsByClassName("u-section-button")[0];

            button.addEventListener('click', function () {

                if(item.classList.contains("u-section--closed")){
                    item.classList.remove("u-section--closed");
                }
                else {
                    item.classList.add("u-section--closed");
                }

            });

        });

        const sectionSeparateButtons = document.querySelectorAll('.u-section-separate-button');

        sectionSeparateButtons.forEach(function (item) {

            var buttonId = item.getAttribute("data-id");

            //find element with the classname u-section-separate that has the same data-id as the button
            var section = document.querySelector('.u-section-separate[data-id="'+buttonId+'"]');

            item.addEventListener('click', function () {

                if(section.classList.contains("u-section-separate--closed")){
                    section.classList.remove("u-section-separate--closed");
                }
                else {
                    section.classList.add("u-section-separate--closed");
                }

            });
        });

    }

    return {
        init: init,
    };
}();
